module.exports = __webpack_public_path__ + "static/media/remove-icon-white.b177722f.svg";